export const state = {
  resources: sessionStorage.getItem('resources')
    ? JSON.parse(sessionStorage.getItem('resources'))
    : {},
  currentAcademicYear: sessionStorage.getItem('current-academic-year')
    ? JSON.parse(sessionStorage.getItem('current-academic-year'))
    : null,
};
